import { render, staticRenderFns } from "./DataTableItemWrap.vue?vue&type=template&id=30959cbe&scoped=true&"
import script from "./DataTableItemWrap.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemWrap.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableItemWrap.vue?vue&type=style&index=0&id=30959cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30959cbe",
  null
  
)

export default component.exports